export const locale = {
    lang: 'en',
    data: {
        'FIELDS': {
            'SelectProject': 'Select Project',
        },
    }
};